import { Permission } from '../../permissions'

export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  perm?: Permission
  pkg?:
    | 'menus'
    | 'categories'
    | 'products'
    | 'options'
    | 'tables'
    | 'tickets'
    | 'roles'
    | 'users'
    | 'feedbacks'
    | 'campaigncodes'
    | 'analytics'
    | 'stocks'
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'analytic',
      displayName: 'menu.analytic',
      meta: {
        icon: 'area_chart',
      },
      perm: 'analytic',
      pkg: 'analytics',
    },
    {
      name: 'menu',
      displayName: 'menu.menu',
      meta: {
        icon: 'menu_book',
      },
      perm: 'menu.read',
      pkg: 'menus',
    },
    {
      name: 'category',
      displayName: 'menu.category',
      meta: {
        icon: 'flatware',
      },
      perm: 'category.read',
      pkg: 'categories',
    },
    {
      name: 'product',
      displayName: 'menu.product',
      meta: {
        icon: 'restaurant',
      },
      perm: 'product.read',
      pkg: 'products',
    },
    {
      name: 'stock',
      displayName: 'Stok Yönetimi',
      meta: {
        icon: 'inventory_2',
      },
      perm: 'stock.read',
      pkg: 'stocks',
    },
    {
      name: 'stock-movements',
      displayName: 'Stok Hareketleri',
      meta: {
        icon: 'history',
      },
      perm: 'stock.movement.read',
      pkg: 'stocks',
    },
    {
      name: 'option',
      displayName: 'menu.option',
      meta: {
        icon: 'settings',
      },
      perm: 'option.read',
      pkg: 'options',
    },
    {
      name: 'campaign-codes',
      displayName: 'Kampanya Kodları',
      meta: {
        icon: 'campaign',
      },
      perm: 'campaigncodes.read',
      pkg: 'campaigncodes',
    },
    {
      name: 'table',
      displayName: 'menu.table',
      meta: {
        icon: 'table_restaurant',
      },
      perm: 'table.read',
      pkg: 'tables',
    },
    {
      name: 'ticket',
      displayName: 'menu.ticket',
      meta: {
        icon: 'receipt_long',
      },
      perm: 'ticket.read',
      pkg: 'tickets',
    },
    {
      name: 'pendingTicket',
      displayName: 'menu.pendingTicket',
      meta: {
        icon: 'receipt',
      },
      perm: 'ticket.pending',
      pkg: 'tickets',
    },
    {
      name: 'role',
      displayName: 'menu.role',
      meta: {
        icon: 'security',
      },
      perm: 'role.read',
      pkg: 'roles',
    },
    {
      name: 'user',
      displayName: 'menu.user',
      meta: {
        icon: 'person',
      },
      perm: 'user.read',
      pkg: 'users',
    },
    {
      name: 'feedback',
      displayName: 'menu.feedback',
      meta: {
        icon: 'feedback',
      },
      perm: 'feedback.read',
      pkg: 'feedbacks',
    },
  ] as INavigationRoute[],
}
